
import React, { useEffect, useState } from 'react'
import { Paragraph, SectionInfo } from 'types/Challenge'
import Typography from 'Components/Base/Typography'
import Row from 'Components/Base/Row'
import Column from 'Components/Base/Column'
import data from 'tria-ui-react-lib/challenges/stepInfo.json'
import ResponsiveContainer from 'Components/Base/ResponsiveContainer'

interface Props {
  isMobile: boolean
  step: number
  setInfoPage: (infoPage: boolean) => void

}
export default function HAYGStep2({ isMobile, step, setInfoPage }: Props) {

  const [sectionInfo, setSectionInfo] = useState<SectionInfo>()

  const [stepParagraphs, setStepParagraphs] = useState<Paragraph[]>()


  useEffect(() => {
    setInfoPage(true)
    window.scrollTo(0, 0)
    setSectionInfo(data.pageInfoBySection.sectionInfo.find((sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2])))
    setStepParagraphs(data.pageInfoBySection.sectionInfo.find((sectionInfo) => sectionInfo.sectionId === parseInt(window.location.pathname.split('/')[window.location.pathname.split('/').length - 2]))?.paragraphs)
  }, [step])

  return (
    <ResponsiveContainer>

      <Column styles={{ margin: isMobile ? '20px auto' : 'auto 0px' }}>
        <Row styles={{ margin: isMobile ? '20px auto' : '20px 0px' }}>
          <Typography variant='h1'>{sectionInfo?.titles.find((title) => title.titleId === 3)?.titleText ?? ''}</Typography>
        </Row>
        <Row styles={{ margin: isMobile ? '20px auto' : '10px 0px' }}>
          <Typography size={20}>{stepParagraphs?.find((paragraph) => paragraph.paragraphId === 4)?.paragraph ?? ''}</Typography>
        </Row>
        <ResponsiveContainer>
          <img src={sectionInfo?.images.find((image) => image.imageId === 2)?.url} alt='scale' style={{ width: isMobile ? '100%' : '25%', marginRight: 15, marginLeft: isMobile ? 0 : -10 }} />
          <img src={sectionInfo?.images.find((image) => image.imageId === 3)?.url} alt='scale' style={{ width: isMobile ? '100%' : '25%', marginRight: 15 }} />
          <img src={sectionInfo?.images.find((image) => image.imageId === 4)?.url} alt='scale' style={{ width: isMobile ? '100%' : '25%', marginRight: 15 }} />
        </ResponsiveContainer>
      </Column>
    </ResponsiveContainer>
  )
}
